export default (defaultSelectedValue = '') => ({
	selectedValue: defaultSelectedValue,
});
